<div class="position-relative cr_content h-auto table-container " style="border-radius: 15px;">
  <div class="calender" *ngIf="isShowCalendar">
    <full-calendar [options]="calendarOptions"></full-calendar>
  </div>
</div>

<div #calendarWrapper class="calendar-wrapper">
  <div *ngIf="isShowPopup" class="calendar-popup" [ngStyle]="{ top: relativePos.y + 'px', left: relativePos.x + 'px' }">
    
    <!-- 1. Move Close Button to the top so it's always visible -->
    <div class="close-btn" (keydown.enter)="isShowPopup = false" (click)="isShowPopup=false">✖</div>

    <!-- 2. Wrap the table in a scrollable container -->
    <div class="table-scroll-container" *ngIf="todaysEventArray.length">
      <table class="task-table">
        <tr>
          <th>Event Type</th>
          <th>Event Name</th>
        </tr>
        <tr *ngFor="let t of todaysEventArray">
          <td class="navigate" (click)="navigate(t)" (keydown.enter)="navigate(t)">{{ t.eventType }}</td>
          <td>{{ t.eventName }}</td>
        </tr>
      </table>
    </div>

  </div>
</div>

<div class="form-template ActivityPage" style="margin-top:1%;"
  *ngIf="coreNavigationService.calenderNavigation == 'Audit Grid'">
  <app-au [activityData]="false"></app-au>
</div>